import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'underscore';
import SingleCountrySelector from '../selectors/country/SingleCountrySelector';
import SingleCompanySelector from '../selectors/company/SingleCompanySelector';
import SimpleDateSelector from '../selectors/date/SimpleDateSelector';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import LANGUAGE_CONTROLLER from '../../controllers/languages';
import Logger, { LOG_LEVELS, ALL_MESSAGES } from '../../utils/logger';
import FilingFrequencySelector from '../selectors/filing/FilingFrequencySelector';
import { FilingTypeEnum, ReturnDisplayType } from '../../utils/enums';
import CONTENT_CONTROLLER from '../../controllers/content';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import { SSelect } from "@avalara/skylab-sdk/react";

const FORM_NAME = 'CUSTOM_DATES';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);
const defaultDueDate = '1899-01-01';
const defaultFrequency = 0;
const INTRASTAT_IN = 'IntrastatIn';
const INTRASTAT_OUT = 'IntrastatOut';
const FREQUENCY_KEY = 'id';
const FREQUENCY_KEY_TO_SET = 'frequency';
export class CustomDates extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filingType: '',
            selectedReturnType: '',
            frequency: defaultFrequency,
            periodStart: '',
            periodEnd: '',
            company: props.selectedCompany,
            country: props.selectedCountry,
            flow: '',
            availablePeriods: []
        };
        this.onCancelClick = this.onCancelClick.bind(this);
        this.onViewClick = this.onViewClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.selectionHandler = this.selectionHandler.bind(this);
    }

    handleChange = (event) => {
        if (event) {
            log.clearAllDictionaryErrors();
            let availablePeriodsTemp = [];
            let periodicityOptions = this.props.reportsPeriodicityOptions;
            //Code to filter frequency selector based on selected country
            if ((event.detail.item.value === FilingTypeEnum.VATRETURN) && periodicityOptions && periodicityOptions.vatReturn) {
                availablePeriodsTemp = this.props.reportsPeriodicityOptions.vatReturn[this.state.country] || [];
            }
            if (event.detail.item.value === INTRASTAT_IN || event.detail.item.value === INTRASTAT_OUT)
                this.setState({
                    filingType: FilingTypeEnum.INTRASTAT,
                    selectedReturnType: event.detail.item.value,
                    'frequency': defaultFrequency,
                    'flow': event.detail.item.value === INTRASTAT_IN ? 'Purchases' : 'Sales'
                });
            else
                this.setState({
                    filingType: event.detail.item.value,
                    selectedReturnType: event.detail.item.value,
                    availablePeriods: availablePeriodsTemp,
                    'frequency': defaultFrequency,
                })
        }
        if (typeof this.props.handleChange === 'function')
            this.props.handleChange();
    };
    selectionHandler(keyValue) {
        if (keyValue) {
            log.clearAllDictionaryErrors();
            let key = Object.keys(keyValue)[0];
            let value = Object.values(keyValue)[0];
            //FilingFrequencySelector returning key as id; hence set correct value for key
            if (key === FREQUENCY_KEY)
                key = FREQUENCY_KEY_TO_SET;
            this.setState({ [key]: value })
        }
        if (typeof this.props.selectionHandler === 'function')
            this.props.selectionHandler();
    }
    UNSAFE_componentWillMount() {
        this.props.onPageLoad();
    }
    onCancelClick() {
        if (typeof this.props.onCancelClick === 'function')
            this.props.onCancelClick();
    }

    getVATNumber(companyId, countryCode) {
        const company = this.props.companyList.find((company) => {
            return company.id == companyId;
        }) || {};
        const vatNumber = _.find(company.vatNumbers, function (vatNumber) {
            return vatNumber.vatnumberCountry == countryCode;
        });
        return vatNumber;
    }
    
    getReturnTypeOptions() {
        const selectedType = this.state.selectedReturnType;
        const optionsList = [{
            label: LANGUAGE_CONTROLLER.format(this.props.languageString, "customDates_SelectReturnType"),
            value: "SelectReturnType",
            selected: selectedType === "SelectReturnType"
        }, {
            label: LANGUAGE_CONTROLLER.format(this.props.languageString, "filingType_VAT"),
            value: "VATReturn",
            selected: selectedType === "VATReturn"
        }, {
            label: LANGUAGE_CONTROLLER.format(this.props.languageString, "filingType_ECListing"),
            value: "ECListing",
            selected: selectedType === "ECListing"
        }, {
            label: LANGUAGE_CONTROLLER.format(this.props.languageString, "filingType_LocalListing"),
            value: "LocalListing",
            selected: selectedType === "LocalListing"
        }, {
            label: LANGUAGE_CONTROLLER.format(this.props.languageString, "filingType_ReverseChargeListing"),
            value: "ReverseChargeListing",
            selected: selectedType === "ReverseChargeListing"
        }, {
            label: LANGUAGE_CONTROLLER.format(this.props.languageString, "filingType_Extrastat"),
            value: "Extrastat",
            selected: selectedType === "Extrastat"
        }, {
            label: LANGUAGE_CONTROLLER.format(this.props.languageString, "customDates_IntrastatIn"),
            value: "IntrastatIn",
            selected: selectedType === "IntrastatIn"
        }, {
            label: LANGUAGE_CONTROLLER.format(this.props.languageString, "customDates_IntrastatOut"),
            value: "IntrastatOut",
            selected: selectedType === "IntrastatOut"
        }, {
            label: LANGUAGE_CONTROLLER.format(this.props.languageString, "filingType_VATBook"),
            value: "VATBook",
            selected: selectedType === "VATBook"
        }, {
            label: LANGUAGE_CONTROLLER.format(this.props.languageString, "filingType_OSSUnion"),
            value: "OSSUnion",
            selected: selectedType === "OSSUnion"
        }, {
            label: LANGUAGE_CONTROLLER.format(this.props.languageString, "filingType_OSSNonUnion"),
            value: "OSSNonUnion",
            selected: selectedType === "OSSNonUnion"
        }, {
            label: LANGUAGE_CONTROLLER.format(this.props.languageString, "filingType_OSSImport"),
            value: "OSSImport",
            selected: selectedType === "OSSImport"
        }];
        return optionsList;
    }

    onViewClick() {
        if (!_.isEmpty(this.state.country) && !_.isEmpty(this.state.company)
            && !_.isEmpty(this.state.filingType) && !_.isEmpty(this.state.periodStart) && !_.isEmpty(this.state.periodEnd)
            && this.state.frequency > 0) {
            var vatNumber = this.getVATNumber(this.state.company, this.state.country);
            if (_.isEmpty(vatNumber)) {
                log.setDictionaryMessage(ALL_MESSAGES.CUSTOM_DATES_NO_VATNUMBER);
            }
            else {
                //Check if end date is not before the start date
                var periodStart = new Date(this.state.periodStart);
                var periodEnd = new Date(this.state.periodEnd);
                if (periodEnd >= periodStart) {
                    var year = periodEnd.getFullYear();
                    var month = periodEnd.getMonth() + 1;
                    let url = '/filing/'
                        + this.state.country + '/'
                        + this.state.company + '/'
                        + this.state.filingType + '/'
                        + defaultDueDate + '/'
                        + this.state.periodStart + '/'
                        + this.state.periodEnd + '/'
                        + month + '/' + year
                        + '?frequency='
                        + this.state.frequency
                        + '&vatnumber='
                        + vatNumber.vatnumber
                        + '&returnDisplayType='
                        + ReturnDisplayType.SHOW_ALL.value;
                    if (!_.isEmpty(this.state.flow))
                        url = url + '&flow=' + this.state.flow;
                    this.props.history.push(url);
                }
            }
        }
        if (typeof this.props.onViewClick === 'function')
            this.props.onViewClick();
    }
    render() {
        return (
            <div data-testid='custom-dates'>
                <h2><LanguageStringResolver string='customDates_Title' /></h2>
                <ApplicationMessages
                    scopes={[FORM_NAME]}
                    messageIds={
                        [
                            ALL_MESSAGES.CUSTOM_DATES_NO_VATNUMBER,
                        ]
                    }
                    messageType="applicationError"
                />
                <s-box >
                    <s-col span="6">
                        <fieldset>
                            <label><LanguageStringResolver string='customDates_Company' /></label>
                            <SingleCompanySelector
                                companyList={this.props.companyList}
                                selectedCompanyId={this.state.company}
                                fieldName="company"
                                selectionHandler={this.selectionHandler.bind(this)}
                            />
                            <label className="mt10"><LanguageStringResolver string='customDates_Country' /></label>
                            <SingleCountrySelector
                                countryList={this.props.countryList}
                                selectedCountryCode={this.state.country}
                                fieldName="country"
                                selectionHandler={this.selectionHandler.bind(this)}
                            />
                            <label className="mt10"><LanguageStringResolver string='customDates_ReturnType' /></label>
                            <div data-test="component-openreturn-filing-select" className="component-openreturn-filing-select">
                                <SSelect defaultValue={this.state.selectedReturnType} 
                                    inputId="single-filingType-select"
                                    name="type"
                                    onS-select={this.handleChange}
                                    optionsList={this.getReturnTypeOptions() || []}
                                    multiple={false}
                                    showSelectionCount={false}
                                />
                            </div>
                            <div className="mt10"></div>
                            <FilingFrequencySelector
                                inline={false}
                                selectionHandler={this.selectionHandler.bind(this)}
                                value={this.state.frequency || -1}
                                validPeriodIds={this.state.availablePeriods}
                                filingTypeId={this.state.filingType || ''}
                                labelText={<LanguageStringResolver string="customDates_Frequency" />}
                                showDefaultValue={true}
                            />
                            <label className="mt10"><LanguageStringResolver string='customDates_PeriodStart' /></label>
                            <SimpleDateSelector
                                format="yyyy-mm-dd"
                                selectionHandler={this.selectionHandler.bind(this)}
                                fieldName="periodStart"
                                name="periodStart"
                                value={this.state.periodStart}
                                dataTestID="custom-dates-start-period"
                            />
                            <label className="mt10"><LanguageStringResolver string='customDates_PeriodEnd' /></label>
                            <SimpleDateSelector
                                format="yyyy-mm-dd"
                                selectionHandler={this.selectionHandler.bind(this)}
                                fieldName="periodEnd"
                                name="periodEnd"
                                value={this.state.periodEnd}
                                dataTestID="custom-dates-end-period"
                            />
                            <span className="clear"></span>
                            <button data-testid='custom-dates-view' className="mt10 primary" onClick={this.onViewClick} >
                                <span><LanguageStringResolver string='customDates_View' /></span>
                            </button>
                            <button data-testid='custom-dates-cancel' className="mt10 secondary" onClick={this.onCancelClick}><LanguageStringResolver string='customDates_Cancel' /></button>
                        </fieldset>
                        <span className="clear"></span>
                    </s-col>
                </s-box>
            </div>
        )
    }
}


CustomDates.defaultProps = {
    countryList: [],
    companyList: [],
    reportsPeriodicityOptions: {},
    onCancelClick: () => { }

}
function mapDispatchersToProps(dispatch) {
    return {
        onPageLoad: () => {
            dispatch(CONTENT_CONTROLLER.getReportPeriodicityOptions());
        }
    }
}

function mapStateToProps(state) {
    return {};
}
export default withRouter(connect(mapStateToProps, mapDispatchersToProps)(CustomDates));